import Http from '_u/request'
import { Toast } from 'vant'
import { lblApiConfig } from '@/config'

const http = new Http()
const queue = {}

const Request = async ({ data = {}, ...config }) => {
  if (!config.method) config.method = 'post'
  if (!config.headers) config.headers = { 'Content-Type': 'application/json' }
  else if (!config.headers['Content-Type']) config.headers['Content-Type'] = 'application/json'
  const { apiLoading, apiReject, ...parameters } = data
  // 请求等待
  if (apiLoading) {
    queue[config.url] = Toast({
      message: typeof apiLoading === 'string' ? apiLoading : '加载中',
      forbidClick: true,
      duration: 0,
      className: 'lbl-loading',
      icon: 'circle'
    })
  }
  let res = null
  try {
    res = await http.request({
      ...config,
      parameters: {
        ...lblApiConfig,
        params: parameters
      }
    })
    res = {
      code: res.result,
      data: res.params,
      msg: res.message
    }
  } catch (err) {
    res = err
  } finally {
    // 请求等待结束
    if (queue[config.url]) {
      queue[config.url].clear()
      delete queue[config.url]
    }
  }
  // 请求错误反馈
  if ((!apiReject || (typeof apiReject === 'number' && res.code !== apiReject)) && res.code !== 1) {
    Toast({
      message: res.message || res.msg,
      forbidClick: true,
      icon: require('img/lbl/icon/close.png')
    })
  }
  if (res.code === 1) {
    console.log('%c%s %O', 'color: green;', `api${config.title}成功`, res)
  } else console.error(`${config.title}失败`, res, parameters)
  return res
}

export default Request
